// extracted by mini-css-extract-plugin
export default {"home":"Login_home__UzjaM"};